import { Injectable } from '@angular/core';
import { AlertController, AlertOptions, LoadingController, LoadingOptions, ModalController, ToastController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { EscolherempresacontratoPage } from 'src/app/components-modal/escolherempresacontrato/escolherempresacontrato.page';
import { LocalStorageProvider } from './localstorageprovider';
import { Events } from './eventsservice';

export enum ToastColors {
  primary,
  secondary,
  tertiary,
  success,
  warning,
  danger,
  dark,
  light,
}

interface IAviso extends AlertOptions {
  mensagem?: string;
  titulo?: string;
  cancelText?: string;
  confirmText?: string;
}

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  private event = new Subject<any>();

  constructor(
    public toastController: ToastController,
    private alertCtrl: AlertController,
    private modalController: ModalController,
    private localStorageService: LocalStorageProvider,
    public loadingController: LoadingController,
    public localStorageProvider: LocalStorageProvider,
    public events: Events
  ) {}

  publishToast(data: any) {
    var element = {
      tipo: 'Toast',
      item: data,
    };
    this.event.next(element);
  }

  carregMenuEvent(data: any) {
    var element = {
      tipo: 'CarregaMenu',
      item: data,
    };
    this.event.next(element);
  }

  getObservable(): Subject<any> {
    if (this.event) {
      return this.event;
    }
  }

  /**
   *
   * @param AlertParams Parâmetros do alerta.
   * @param cb Função callback que será executada ao clicar em um dos botões do alerta.
   * @returns Promise<boolean> Retorna uma promise com o valor true ou false, dependendo do botão clicado.
   *
   * @example
   * const isConfirm = await this.globalService.showAviso({
   * mensagem: 'Deseja realmente executar esta ação?',
   * titulo: 'Aviso',
   * });
   *
   * @example
   * this.globalService.showAviso({
   * mensagem: 'Deseja realmente executar esta ação?',
   * titulo: 'Aviso',
   * }, (isConfirm) => {
   * // do smt
   * });
   */
  async showAviso(
    mensagem: IAviso | string,
    cb: (isConfirm: boolean) => void = () => {}
  ): Promise<boolean> {
    let params: IAviso = {
      titulo: 'Aviso',
      mensagem: 'Deseja mesmo executar esta ação?',
      cancelText: 'Cancelar',
      confirmText: 'Confirmar',
    };

    // Permite enviar apenas string, caso não queria passar um objeto com os parâmetros.
    if (typeof mensagem === 'string') {
      params.mensagem = mensagem;
    } else {
      params = mensagem;
    }

    return new Promise(async (resolve) => {
      const alert = await this.alertCtrl.create({
        header: params.titulo || params.header,
        message: params.mensagem,
        backdropDismiss: false,
        ...params,
        buttons: [
          {
            text: params.cancelText || "Cancelar",
            role: 'cancel',
            handler: () => {
              cb(false);
              resolve(false);
            },
          },
          {
            text: params.confirmText || "Confirmar",
            role: 'confirm',
            handler: () => {
              cb(true);
              resolve(true);
            },
          },
        ],
      });

      await alert.present();
    });
  }

  async showLoading(options?: LoadingOptions): Promise<HTMLIonLoadingElement>
  {
    if(options)
    {
      options.message ??= "Aguarde...";
    }

    const loading = await this.loadingController.create(options ? options : {message: "Aguarde..."});

    loading.present();

    return loading;
  }

  async presentToast(
    message: string,
    color: ToastColors = ToastColors.primary,
    duration: number = 10000
  ) {
    const toast = await this.toastController.create({
      message,
      duration,
      buttons: [
        {
          side: 'end',
          //icon: 'star',
          role: 'cancel',
          text: 'Fechar',
          handler: () => {},
        },
      ],
      color: ToastColors[color],
      position: 'top',
    });
    toast.present();
  }

  devconsole(message: string, obj: any) {
    this.devlog(message, obj);
  }

  devlog(...params: any[]) {
    if (
      location.hostname === 'localhost' ||
      location.hostname === '127.0.0.1'
    ) {
      //console.log('devconsole - ', ...params);
    }
  }

  clearConfig(){
    const configUser = this.localStorageProvider.getUserConfig();

    configUser.numContrato = "";
    configUser.loja = "";
    configUser.shoppingCod = "";
    configUser.shoppingTexto = "";
    this.localStorageProvider.saveUserConfig(configUser);

    this.events.publish('app.refreshData', {});
  }

  async createModalEmpresaContrato(nomeMenu: string = "") {
    const {Config} = this.localStorageService.loggedUser;

    const modal = await this.modalController.create({
      component: EscolherempresacontratoPage,
      cssClass: 'modal-edicao',
      componentProps: {
        shopping: Config.shoppingCod,
        loja: Config.loja,
        nomeMenu: nomeMenu,
      },
    });

    return modal;
  }
}
